import { Component, inject, OnInit } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'

const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg']

@Component({
    standalone: true,
    template: `
        <div class="modal-header">
            <h5 class="modal-title">{{ fileName }}</h5>
            <button type="button" class="btn-close" (click)="activeModal.dismiss()"></button>
        </div>
        <div class="modal-body" style="min-height: 300px;">
            @if (isPdf) {
                <iframe [src]="safeUrl" style="width: 100%; height: 80vh; border: none;"></iframe>
            } @else if (isImage) {
                <div class="text-center">
                    <img [src]="safeUrl" class="img-fluid" style="max-height: 80vh;" />
                </div>
            } @else {
                <div class="text-center" style="padding: 40px;">
                    <p>This file type cannot be previewed in the browser.</p>
                    <a [href]="safeUrl" download class="btn btn-primary">Download {{ fileName }}</a>
                </div>
            }
        </div>
        <div class="modal-footer">
            <a [href]="safeUrl" download class="btn btn-outline-secondary">Download</a>
            <button class="btn btn-secondary" (click)="activeModal.dismiss()">Close</button>
        </div>
    `,
})
export class AttachmentPreviewModalComponent implements OnInit {
    activeModal = inject(NgbActiveModal)
    private sanitizer = inject(DomSanitizer)

    previewUrl = ''
    fileName = ''
    contentType = ''

    safeUrl!: SafeResourceUrl
    isPdf = false
    isImage = false

    ngOnInit() {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.previewUrl)
        const ext = this.getExtension(this.fileName)
        this.isPdf = ext === '.pdf'
        this.isImage = IMAGE_EXTENSIONS.includes(ext)
    }

    private getExtension(name: string): string {
        const dot = name.lastIndexOf('.')
        return dot >= 0 ? name.substring(dot).toLowerCase() : ''
    }
}
